import styled from 'styled-components';

export const Body = styled.div`
  margin-top: 0;
  width: 100%;

  .login-bar {
    background-color: ${(props) => props.theme.$dark};

    a {
      color: ${(props) => props.theme.$white};
      text-decoration: underline;
    }
  }
`;

export const Container = styled.div.attrs({
  className: 'container',
})`
  align-content: center;

  .separator {
    width: 1px;
    height: 24px;
    background-color: white;
    margin: 0 20px;
  }

  .contact {
    gap: 5px;
  }

  @media screen and (max-width: 576px) {
    padding: 0px;

    .contact {
      background-color: rgba(0, 0, 0, 0.5);
      gap: 5px;
    }

    .logo {
      img {
        width: 120px;
      }

      span {
        font-size: 14px;
      }

      .separator {
        margin: 0 10px;
      }
    }
  }
`;
